export default class Analytics {
  constructor(key, distributorId) {
    this.key = key
    this.distributorId = distributorId
    this.trackerData = {
      trackerNamespace: "web-player",
      appId: key,
      platform: "web",
      userId: "test_user_id",
      language: "en",
    }
    this.commonData = {}
  }

  // eslint-disable-next-line class-methods-use-this
  get snowplow() {
    return window.spSnowplowTracker ? window.spSnowplowTracker : () => {
      // eslint-disable-next-line no-console
      console.error("Snowplow tracker was not setup.")
      // eslint-disable-next-line no-console, prefer-rest-params
      console.warn("dropped event: ", arguments)
    }
  }

  trackSessionEvent(event, data = {}) {
    this._track("session", event, data)
  }

  trackStoryEvent(event, data = {}) {
    this._track("story", event, data)
  }

  trackPlayerInit(playlistParams, displayParams, width) {
    this._trackStructEvent("app", "init", JSON.stringify(playlistParams), JSON.stringify(displayParams), width)
  }

  trackNoStoriesEvent(params) {
    this._trackStructEvent("app", "no_stories", "", JSON.stringify(params))
  }

  _track(schema, event, data = {}) {
    // eslint-disable-next-line no-console
    console.debug(schema, event)
    this.snowplow("trackUnstructEvent", {
      schema: `iglu:com.spokenlayer/${schema}/jsonschema/1-0-0`,
      data: {
        tracker: this.trackerData,
        common: this.commonData,
        eventData: {
          eventName: event,
          distributorId: this.distributorId,
          ...data,
        },
      },
    })
  }

  _trackStructEvent(category, action, label, property, value, context) {
    // eslint-disable-next-line no-console
    console.debug("_trackStructEvent", {
      category,
      action,
      label,
      property,
      value,
      context,
    })
    this.snowplow(
      "trackStructEvent",
      category,
      action,
      label,
      property,
      value,
      context
    )
  }
}



// WEBPACK FOOTER //
// ./src/utils/analytics.js